import * as React from 'react';
import {compose} from "recompose";
import {Col, Input, Row, Spin, Tooltip} from 'antd';

import Firebase, {withFirebase} from "../../components/Firebase";

import Course from "../Course/Course";
import MyCourses from './MyCourses';
import CourseItem from './CourseItem';

import './Courses.css';

import {gaSearchCourses} from '../../ga/course';

const Search = Input.Search;

interface IProps {
  firebase: Firebase;
}

interface IState {
  courses: Course[] | 'loading';
  searchResult: string;
}

class Courses extends React.Component<IProps, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      courses: [],
      searchResult: '',
    };
  }


  // Actions
  searchCourses = async (value: string) => {
    if (!value || this.state.courses === 'loading') {
      return;
    }
    gaSearchCourses(value);

    this.setState(() => ({courses: 'loading'}));
    try {
      const querySnapshot = await this.props.firebase.searchCoursesByName(value.toLowerCase());
      const courses: any[] = [];
      querySnapshot.forEach((doc) => {
        courses.push(doc.data());
      });

      this.setState(() => ({courses, searchResult: `Found ${courses.length} courses`}));
    } catch (e) {
      console.log(e);
    }
  }

  public render() {
    const {courses} = this.state;

    const coursesList = (() => {
      if (courses === 'loading') {
        return <Spin size='large' />
      }
      if (courses.length === 0) {
        return '';
      }

      return courses.map((course: any) => {
        return (
          <CourseItem course={course} school="TODO" key={course.name}/>
        );
      });
    })();

    return(
      <div className='courses'>

        <Row gutter={16}>

          <Col span={17} className='main-section'>

            <Tooltip placement="top" title='No need to type full course name'>
              <Search placeholder='Type and hit Enter' size='large' style={{width: '60%', marginBottom: '3px'}}
                      onSearch={this.searchCourses} />
            </Tooltip>
            <br/>
            <span>{this.state.searchResult}</span>

            <div className='content' style={{marginTop: '5px'}}>
              <div className="courses-list">
                {coursesList}
              </div>
            </div>

          </Col>

          <Col span={7} className='content'>
            <MyCourses />
          </Col>

        </Row>

      </div>
    )
  }


}

export default compose(
  withFirebase
)(Courses);